import styled, { css } from 'styled-components';

const AccordionIconWrapper = styled.div`
  transition: all 0.3s;
  display: flex;
  align-items: center;

  ${(props) =>
    props.show
      ? css`
          transform: rotate(-180deg);
        `
      : null};
`;

export default AccordionIconWrapper;
